import { AxiosInstance } from '../../helpers/AxiosInstance';
import Config from '../../config';


const getImprovedMessage = (data:
    {
        message: string,
        improve: boolean,
        length: string,
        tone: string,
        channel: number,
        translate?: string
    }
) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/refine-message`, data);
};//get improved message using ai service

const getWebsiteRefinedMessage = (data:
    {
        message: string,
        improve: boolean,
        length: string,
        tone: string,
        translate: string,
    }
) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/refine-website-message`, data);
};//get improved message using ai service in website

const getChatSummaryandSentiment = (data:
    {
        text: string,
        channel: number,
        contact: string
    }
) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/chat-summary-with-sentiment`, data);
};//get chat summary and customer review

const getLastGeneratedChatSummaryandSentimentByParticipantId = (ParticipantID: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/get-summary/${ParticipantID}`);
};//get chat summary and customer review


const UploadFilesToAi = (data) => {

    const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    };

    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/uploadFile`, data);
};//upload files to falkon ai

const TrainUploadFilesToAi = (data:
    {
        organization_id: string,
    }) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/queue-pdf`, data);
};//feed the falkon ai with the uploaded files

const TrainFailedFileToAi = (data:
    {
        organization_id: string,
        file_name: string,
    }) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/ag/queue-one-pdf`, data);
};//feed the failed file to falkon ai again

const DeleteTrainedFileFromAi = (data:
    {
        organization_id: string,
        file_name: string,
        agent_id?: string
    }) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/deleteFile`, data);
};//delete the file data from falkon ai

const getAllFiles = (OrganizationID: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/ag/listfiles?organization_id=${OrganizationID}`);
};//get all the files uploaded for falkon ai


const getAllFilesByAgentId = (OrganizationID: string, AgentId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/ag/listfiles?organization_id=${OrganizationID}&agent_id=${AgentId}`);
};//get all the files uploaded for falkon ai for a specific agent


const getLastGeneratedChatSummaryandSentimentByPhoneNumber = (PhoneNumber: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/get-summary/${PhoneNumber}`);
};//get chat summary and customer review

const getReplySuggestions = (data:
    {
        organization_id: string,
        message: string,
        text: string,
        image_urls: string[]
    }) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/suggest-reply-array-with-context-and-vision`, data);
};//get reply suggestions based on the feed data



const TrainUrlsToAi = (data: {
    organization_id: string,
    urls: string[],
    base_url: string,
    agent_id?: string
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/ag/scrape-web-pages`, data);
};//send the urls that needs to be scraped and trained by falkon ai

const DeleteTrainedUrlsFromAi = (data: {
    organization_id: string,
    website_urls: string[],
    agent_id?: string
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/ag/delete-web-scrape-urls`, data);
};//delete the data trained by urls from falkon ai

const WebsiteToCrawlandgetAllowedLinks = (data: {
    organization_id: string,
    website_url: string
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/ag/get-allowed-links`, data);
};//get all the allowed links to scrape by crawling given website

const getAllUrlsByOrg = (OrganizationID: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/ag/get-web-page-links-details/${OrganizationID}`);
};//get all the urls sent for training to falkon ai by org scope

const getAllUrlsByAgent = (OrganizationID: string, AgentId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/ag/get-web-page-links-details/${OrganizationID}/${AgentId}`);
};//get all the urls sent for training to falkon ai by agent scope

const TrainChatHistoryToAi = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/Messages/PostChatParagraph`);
};//train chat history of the organisation to falkon ai

const DeleteChatHistoryFromAi = (data: {
    organization_id: string
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/delete-chat-history`, data);
};//delete the trained chat history from falkon ai

const getChatHistoryDetails = (OrganizationID: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/get-chat-history-details/${OrganizationID}`);
};//get chat history details trained to falkon ai

const updateSuggestedRepliesAcceptancy = (data: { suggestion_id: string, user_acceptancy: boolean }) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/update-user-acceptance`, data);
};//get update suggestion acceptancy

const getAcceptancyRateDetails = () => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/suggested-reply-stats`);
};//get suggestion replies analytics in system admin

const UpdateAiFeaturesAvailableStatus = (orgId: string, value: string) => {
    return AxiosInstance.patch(`${Config.FALKON_CONNECT_API}/api/v1/ai/features/${orgId}/${value}`);
}// enable/disable ai features for organization

const UpdateAiChatBotStatus = (orgId: string, value: string) => {
    return AxiosInstance.patch(`${Config.FALKON_CONNECT_API}/api/v1/chatbot/org/${orgId}/${value}`);
}// enable/disable chat bot for organization

const UpdateBotSettings = (organization_id: string, agent_id: string, data: {
    name?: string,
    description?: string,
    configuration?: {
        fallback_message: string,
        num_of_conversations: number,
        character_count: number
    },
    status?: string
}) => {

    return AxiosInstance.put(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/org-agents/${organization_id}/${agent_id}`, data);
}//configs for chat bot

const getBotSettings = (orgId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/get/bot-settings/${orgId}`);
}//get bot configs

const getAiChatBotStatus = (orgId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_API}/api/v1/chatbot/org/${orgId}`);
}// get enable/disable status of chat bot for organization

const getAiFeaturesAvailableStatus = (orgId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_API}/api/v1/ai/features/${orgId}`);
}// get enable/disable status of ai features for organization

const getAiCredits = (orgId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_API}/api/v1/ai/credit/org/${orgId}`);
}// get ai credits for organization

const getAllAgents = (orgId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/org-agents/${orgId}`);
}

const createNewAgent = (data: {
    organization_id: string,
    org_name: string,
    name: string,
    description: string,
    configuration: {
        fallback_message: string,
        num_of_conversations: number,
        character_count: number
    },
    status: string
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/org-agents`, data);
}

const deleteAgent = (orgId:string,AgentId: string) => {
    return AxiosInstance.delete(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/org-agents/${orgId}/${AgentId}`);
}

const getAssignedChannelsToAgent = (orgId: string, AgentId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/get/org-units/${orgId}/${AgentId}`);
}

const getChannels = (orgId: string) => {
    return AxiosInstance.get(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/get/org-units/${orgId}`);
}

const AssignedChannelToAgent = (data: {
    organization_id: string,
    unit_id: string,
    agent_id: string,
    unit_name: string,
    unit_type: number,
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/org-units/assign-agent`, data);
}

const UnAssignedChannelFromAgent = (data: {
    organization_id: string,
    unit_id: string,
    agent_id: string,
}) => {
    return AxiosInstance.post(`${Config.FALKON_CONNECT_AI_URL}/falkon-chat-ai/api/org-units/unassign-agent`, data);
}

export const ChannelAiService = {
    getImprovedMessage,
    getWebsiteRefinedMessage,
    getChatSummaryandSentiment,
    getLastGeneratedChatSummaryandSentimentByParticipantId,
    getReplySuggestions,
    UploadFilesToAi,
    TrainUploadFilesToAi,
    TrainFailedFileToAi,
    DeleteTrainedFileFromAi,
    getAllFiles,
    TrainUrlsToAi,
    WebsiteToCrawlandgetAllowedLinks,
    getAllUrlsByOrg,
    getAllUrlsByAgent,
    DeleteTrainedUrlsFromAi,
    TrainChatHistoryToAi,
    DeleteChatHistoryFromAi,
    getChatHistoryDetails,
    updateSuggestedRepliesAcceptancy,
    getAcceptancyRateDetails,
    getLastGeneratedChatSummaryandSentimentByPhoneNumber,
    getAiFeaturesAvailableStatus,
    getAiChatBotStatus,
    getBotSettings,
    UpdateBotSettings,
    UpdateAiChatBotStatus,
    UpdateAiFeaturesAvailableStatus,
    getAiCredits,
    getAllAgents,
    createNewAgent,
    deleteAgent,
    getAllFilesByAgentId,
    getAssignedChannelsToAgent,
    getChannels,
    AssignedChannelToAgent,
    UnAssignedChannelFromAgent
}